import React, { lazy } from "react"
import { Navigate } from "react-router-dom"
import { HOME_SCREEN, NOT_ENABLED_SCREEN } from "./route-list"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"
const NotEnabled = React.lazy(
  () => import("@/features/settings-account/views/not-purchased/not-enabled"),
)
const Home = lazy(() => import("@/features/home/views/home/home"))
const BottomMenuLayout = lazy(
  () => import("@/layouts/bottom-menu-layout/bottom-menu-layout.tsx"),
)

export const noMenuLayoutHomeRoutes = [
  {
    path: NOT_ENABLED_SCREEN,
    element: <NotEnabled />,
  },
  { path: "/", element: <Navigate to="/home" /> },
]

export const bottomLayoutHomeRoutes = [
  {
    index: true,
    path: HOME_SCREEN,
    element: <Home />,
  },
]

export const MOBILE_NO_MENU_LAYOUT_HOME_ROUTES = {
  element: <NoMenuLayout />,
  children: noMenuLayoutHomeRoutes,
}

export const MOBILE_BOTTOM_MENU_LAYOUT_HOME_ROUTES = {
  element: <BottomMenuLayout />,
  children: bottomLayoutHomeRoutes,
}

const DESKTOP_HOME_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: bottomLayoutHomeRoutes,
  },
  MOBILE_NO_MENU_LAYOUT_HOME_ROUTES,
]

const MOBILE_HOME_ROUTES = [
  MOBILE_NO_MENU_LAYOUT_HOME_ROUTES,
  MOBILE_BOTTOM_MENU_LAYOUT_HOME_ROUTES,
]

export const getHomeRoutes = (isDesktop: boolean) => {
  return isDesktop ? DESKTOP_HOME_ROUTES : MOBILE_HOME_ROUTES
}
